export type SortDirection = 'asc' | 'desc'

export interface SortState {
  field: string | null
  direction: SortDirection | null
}

/** 表头三态循环：无 → 升 → 降 → 无；切换到新字段从升序开始。 */
export function nextSortState(current: SortState, clickedField: string): SortState {
  if (current.field !== clickedField) return { field: clickedField, direction: 'asc' }
  if (current.direction === null) return { field: clickedField, direction: 'asc' }
  if (current.direction === 'asc') return { field: clickedField, direction: 'desc' }
  return { field: null, direction: null }
}

/** 前端本地排序（全量数据在手、无需回服务端的场景）。 */
export function applySort<T>(
  items: readonly T[],
  state: SortState,
  accessors: Record<string, (item: T) => string | number | boolean | null | undefined>
): T[] {
  if (!state.field || !state.direction) return [...items]
  const accessor = accessors[state.field]
  if (!accessor) return [...items]
  const factor = state.direction === 'asc' ? 1 : -1
  return [...items].sort((left, right) => {
    const lv = accessor(left) ?? ''
    const rv = accessor(right) ?? ''
    if (lv === rv) return 0
    return (lv > rv ? 1 : -1) * factor
  })
}

/** 组装查询参数；空态不出参，交由后端默认排序。 */
export function sortParams(state: SortState): { sortField?: string; sortOrder?: SortDirection } {
  if (!state.field || !state.direction) return {}
  return { sortField: state.field, sortOrder: state.direction }
}
